/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, ElementRef, Input} from '@angular/core';
import {Filterable} from '../../mixins/Filterable';
import {Mixin} from '../../mixins/Mixin';

@Component({
    selector: 'ui-form-element',
    template: require('./ui-form-element.html'),
    styles: [require('./ui-form-element.less')],
})
@Mixin([Filterable])
export class UiFormElement {

    @Input() public title: string;
    @Input() public boldTitle: boolean;
    @Input() public description: string;
    @Input() public controlFlex: boolean = false;

    @Input() highlightPhrase: string = '';

    constructor(public elementRef: ElementRef) {}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-form-element/ui-form-element.ts